<template>
  <div>
    <preview-security ref="previewSecurity" :item="item" :show-stamp="true" />
    <div v-if="item.showRecord" style="margin-top: 20px;">
      <h4 style="margin-bottom: 10px;">审核记录</h4>
      <el-table v-if="recordList && recordList.length > 0" :data="recordList" style="width: 100%">
        <el-table-column label="角色">
          <template slot-scope="scope">
            <span v-if="scope.row.role === 1">检测员</span>
            <span v-if="scope.row.role === 2">审核员</span>
            <span v-if="scope.row.role === 3">批准员</span>
          </template>
        </el-table-column>
        <el-table-column label="审核结果" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.result === 1">通过</span>
            <span v-if="scope.row.result === 2">不通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="审核时间" />
        <el-table-column prop="user_sign" label="签名" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.user_sign" :src="baseURL + scope.row.user_sign" alt="" style="width: 100px;">
          </template>
        </el-table-column>
      </el-table>
      <div v-else style="text-align: center; color: #999; padding: 20px;">
        <span>暂无审核记录</span>
      </div>
    </div>
    <div v-if="item.isPrint" style="text-align: center; margin-top: 20px;">
      <el-button type="primary" size="large" :loading="pdfLoading" @click="handlePrint">
        {{ pdfLoading ? '正在生成...' : '打印报告' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import PreviewSecurity from '@/views/verification/Components/PreviewSecurity.vue'
import { detailSecurity } from '@/api/cert'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  name: 'CertPreviewSecurity',
  components: { PreviewSecurity },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      apiBaseURL: process.env.VUE_APP_API,
      recordList: [],
      pdfLoading: false
    }
  },
  watch: {
    'item.id': {
      handler(val) {
        if (val) {
          this.loadData()
        }
      },
      immediate: true
    }
  },
  methods: {
    loadData() {
      this.$set(this.item, 'loading', true)
      detailSecurity(this.item.id).then(response => {
        const data = response.data
        this.$set(this.item, 'data', data)
        this.recordList = data.approved_memo || []
        this.$set(this.item, 'loading', false)
      }).catch(() => {
        this.$set(this.item, 'loading', false)
      })
    },
    async handlePrint() {
      this.pdfLoading = true

      try {
        console.log('开始生成PDF...')
        const printElement = document.getElementById('printContentSecurity')
        if (!printElement) {
          this.$message.error('未找到打印内容')
          this.pdfLoading = false
          return
        }

        console.log('开始预加载图片...')
        await this.preloadAllImages(printElement)
        console.log('预加载完成，开始转换图片...')

        const imageBase64Map = await this.convertImagesToBase64Map(printElement)
        console.log(`图片转换完成，获得 ${imageBase64Map.size} 个 base64 数据`)

        console.log('图片转换完成，开始生成PDF...')

        const pages = printElement.querySelectorAll('.page')
        console.log(`找到 ${pages.length} 页`)

        if (pages.length === 0) {
          this.$message.error('未找到可打印的页面')
          this.pdfLoading = false
          return
        }

        const pdf = new JsPDF('p', 'mm', 'a4')

        for (let i = 0; i < pages.length; i++) {
          console.log(`正在处理第 ${i + 1} 页...`)
          const page = pages[i]

          const pageWidth = 210
          const pageHeight = 297
          const paddingLeft = 0
          const paddingTop = 0
          const contentWidth = pageWidth - (paddingLeft * 2)
          const contentHeight = pageHeight - (paddingTop * 2)

          const canvas = await this.html2CanvasWithTimeout(page, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: false,
            backgroundColor: '#ffffff',
            width: page.offsetWidth,
            height: page.offsetHeight,
            windowWidth: page.scrollWidth,
            windowHeight: page.scrollHeight,
            imageTimeout: 15000,
            onclone: (clonedDoc) => {
              console.log(`第 ${i + 1} 页: onclone 回调触发`)
              const clonedImages = clonedDoc.querySelectorAll('img')
              console.log(`  找到 ${clonedImages.length} 张图片`)

              clonedImages.forEach((clonedImg, index) => {
                const originalSrc = clonedImg.getAttribute('src')
                console.log(`  图片 ${index + 1}: ${originalSrc}`)

                if (originalSrc) {
                  if (imageBase64Map.has(originalSrc)) {
                    clonedImg.src = imageBase64Map.get(originalSrc)
                    console.log(`    ✓ 替换成功 (base64)`)
                  } else {
                    console.log(`    ✗ 未找到对应的 base64 数据`)
                    for (const [key, value] of imageBase64Map.entries()) {
                      if (originalSrc.includes(key) || key.includes(originalSrc)) {
                        clonedImg.src = value
                        console.log(`    ✓ 模糊匹配替换成功`)
                        break
                      }
                    }
                  }
                }
              })
            }
          }, 10000)

          if (!canvas) {
            console.error(`第 ${i + 1} 页渲染失败`)
            continue
          }

          const imgData = canvas.toDataURL('image/png', 1.0)

          const imgWidth = contentWidth
          const imgHeight = (canvas.height * imgWidth) / canvas.width

          const finalHeight = Math.min(imgHeight, contentHeight)

          if (i > 0) {
            pdf.addPage()
          }

          pdf.addImage(imgData, 'PNG', paddingLeft, paddingTop, imgWidth, finalHeight)
          console.log(`第 ${i + 1} 页处理完成`)
        }

        console.log('PDF生成完成，准备打印...')
        pdf.autoPrint()
        window.open(pdf.output('bloburl'), '_blank')

        this.$message.success('报告已生成，正在打印...')
        console.log('打印完成')
      } catch (error) {
        console.error('生成PDF失败:', error)
        this.$message.error('生成PDF失败，请重试')
      } finally {
        this.pdfLoading = false
      }
    },
    html2CanvasWithTimeout(element, options, timeout = 10000) {
      return new Promise((resolve) => {
        const timeoutId = setTimeout(() => {
          console.warn('html2canvas 渲染超时，使用降级方案...')
          resolve(null)
        }, timeout)

        html2Canvas(element, options)
          .then(canvas => {
            clearTimeout(timeoutId)
            resolve(canvas)
          })
          .catch(error => {
            clearTimeout(timeoutId)
            console.error('html2canvas 渲染失败:', error)
            resolve(null)
          })
      })
    },
    preloadAllImages(element) {
      return new Promise((resolve) => {
        const images = Array.from(element.querySelectorAll('img'))
        let loadedCount = 0
        const totalImages = images.length

        console.log(`发现 ${totalImages} 张图片`)

        if (totalImages === 0) {
          resolve()
          return
        }

        const checkComplete = () => {
          loadedCount++
          console.log(`已加载 ${loadedCount}/${totalImages}`)
          if (loadedCount >= totalImages) {
            resolve()
          }
        }

        const timeout = setTimeout(() => {
          console.log('图片加载超时，继续下一步...')
          resolve()
        }, 5000)

        images.forEach(img => {
          if (img.complete && img.naturalWidth > 0) {
            console.log('图片已加载:', img.src)
            checkComplete()
          } else {
            const onLoad = () => {
              console.log('图片加载成功:', img.src)
              img.removeEventListener('load', onLoad)
              img.removeEventListener('error', onError)
              checkComplete()
            }
            const onError = () => {
              console.warn('图片加载失败:', img.src)
              img.removeEventListener('load', onLoad)
              img.removeEventListener('error', onError)
              checkComplete()
            }
            img.addEventListener('load', onLoad)
            img.addEventListener('error', onError)
          }
        })

        images.forEach(img => {
          if (img.complete && img.naturalWidth > 0) {
            clearTimeout(timeout)
            checkComplete()
          }
        })
      })
    },
    getAbsoluteUrl(relativeOrAbsoluteUrl) {
      if (!relativeOrAbsoluteUrl) return relativeOrAbsoluteUrl

      if (relativeOrAbsoluteUrl.startsWith('data:') ||
          relativeOrAbsoluteUrl.startsWith('http://') ||
          relativeOrAbsoluteUrl.startsWith('https://')) {
        return relativeOrAbsoluteUrl
      }

      const baseUrl = window.location.origin
      return baseUrl + relativeOrAbsoluteUrl
    },

    getRelativeUrl(absoluteUrl) {
      if (!absoluteUrl) return absoluteUrl

      if (absoluteUrl.startsWith('data:') ||
          absoluteUrl.startsWith('http://') ||
          absoluteUrl.startsWith('https://')) {
        const currentOrigin = window.location.origin
        if (absoluteUrl.startsWith(currentOrigin)) {
          return absoluteUrl.substring(currentOrigin.length)
        }
      }

      return absoluteUrl
    },

    async convertImagesToBase64Map(element) {
      const images = Array.from(element.querySelectorAll('img'))
      console.log(`开始转换 ${images.length} 张图片`)

      const imageMap = new Map()
      let successCount = 0
      let failCount = 0

      for (const img of images) {
        const src = img.getAttribute('src')

        if (!src) {
          console.warn('图片没有 src 属性')
          continue
        }

        console.log(`准备转换图片: ${src}`)

        if (src.startsWith('data:image')) {
          console.log('  → 图片已是 base64 格式')
          imageMap.set(src, src)
          const absoluteUrl = this.getAbsoluteUrl(src)
          if (absoluteUrl !== src) {
            imageMap.set(absoluteUrl, src)
          }
          successCount++
          continue
        }

        try {
          const base64 = await this.loadImageAsBase64(img)
          if (base64) {
            imageMap.set(src, base64)
            const absoluteUrl = this.getAbsoluteUrl(src)
            if (absoluteUrl !== src) {
              imageMap.set(absoluteUrl, base64)
            }
            const relativeUrl = this.getRelativeUrl(src)
            if (relativeUrl !== src) {
              imageMap.set(relativeUrl, base64)
            }
            successCount++
            console.log(`  → 转换成功, base64 长度: ${base64.length}`)
          } else {
            failCount++
            console.warn(`  → 转换失败`)
          }
        } catch (error) {
          console.error('转换图片时出错:', error)
          failCount++
        }
      }

      console.log(`图片转换完成: 成功 ${successCount}, 失败 ${failCount}`)
      console.log(`Map 大小: ${imageMap.size}`)
      for (const [key] of imageMap.entries()) {
        console.log(`  - ${key}`)
      }

      return imageMap
    },
    async loadImageAsBase64(img) {
      const src = img.getAttribute('src') || img.src

      if (!src || src.startsWith('data:')) {
        if (src && src.startsWith('data:')) {
          return src
        }
        return null
      }

      if (img.complete && img.naturalWidth > 0) {
        const base64 = this.imageToBase64(img)
        if (base64) {
          return base64
        }
      }

      try {
        const base64 = await this.fetchImageAsBase64(src)
        return base64
      } catch (error) {
        console.warn(`Failed to fetch image: ${src}`, error)
        return null
      }
    },
    async fetchImageAsBase64(url) {
      const proxyUrl = this.getProxyUrl(url)
      console.log(`  [fetchImageAsBase64] URL: ${url}`)
      console.log(`  [fetchImageAsBase64] Proxy URL: ${proxyUrl}`)
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.timeout = 10000

        xhr.onload = () => {
          console.log(`  [fetchImageAsBase64] Status: ${xhr.status}, Response size: ${xhr.response ? xhr.response.size : 'N/A'}`)
          if (xhr.status === 200) {
            try {
              const blob = xhr.response
              const reader = new FileReader()
              reader.onloadend = () => {
                const result = reader.result
                console.log(`  [fetchImageAsBase64] Base64 prefix: ${result.substring(0, 50)}...`)
                resolve(result)
              }
              reader.onerror = () => {
                console.error(`  [fetchImageAsBase64] FileReader error`)
                reject(new Error('FileReader failed'))
              }
              reader.readAsDataURL(blob)
            } catch (error) {
              console.error(`  [fetchImageAsBase64] Error: ${error}`)
              reject(error)
            }
          } else {
            console.error(`  [fetchImageAsBase64] HTTP error: ${xhr.status}`)
            reject(new Error(`HTTP ${xhr.status}`))
          }
        }

        xhr.onerror = () => {
          console.error(`  [fetchImageAsBase64] Network error`)
          reject(new Error('Network error'))
        }

        xhr.ontimeout = () => {
          console.error(`  [fetchImageAsBase64] Timeout`)
          reject(new Error('Timeout'))
        }

        xhr.open('GET', proxyUrl, true)
        xhr.responseType = 'blob'
        xhr.withCredentials = false
        xhr.send()
      })
    },
    getProxyUrl(url) {
      if (!url) return url

      const currentHost = window.location.hostname
      let urlObj
      try {
        urlObj = new URL(url)
      } catch (e) {
        return url
      }

      const externalDomains = ['api.zgcxjx.cn', 'zgcxjx.cn']
      if (externalDomains.includes(urlObj.hostname) && urlObj.hostname !== currentHost) {
        const encodedUrl = encodeURIComponent(url)
        return `${this.apiBaseURL}/common/proxy-image?url=${encodedUrl}`
      }

      return url
    },
    imageToBase64(img) {
      try {
        const canvas = document.createElement('canvas')
        canvas.width = img.naturalWidth || img.width
        canvas.height = img.naturalHeight || img.height

        if (canvas.width === 0 || canvas.height === 0) {
          return null
        }

        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        const dataURL = canvas.toDataURL('image/png', 1.0)
        return dataURL
      } catch (error) {
        console.warn('Canvas toDataURL failed:', error)
        return null
      }
    }
  }
}
</script>

<style scoped>
@media print {
  .el-button {
    display: none !important;
  }
}
</style>
